import type {
  Vh3FrontendV2ApiDocumentationDocumentsDocIdGetData,
  Vh3FrontendV2ApiDocumentationDocumentsUploadPdfPostData,
} from './generated/Api';

export type DocumentStatus = 'processing' | 'ready' | 'error';

type GeneratedDocument =
  Vh3FrontendV2ApiDocumentationDocumentsDocIdGetData[number];

export type DocumentationDocument = {
  id: string;
  file: {
    url: string;
  };
  name: string;
  quiz?: {
    questions: {
      [key: string]: {
        text: string;
        answer: string;
        options: {
          A: string;
          B: string;
          C: string;
          D: string;
        };
      };
    }[];
  };
  status: DocumentStatus;
  is_shared: boolean;
  category: string;
  summary: string;
  created_at: number;
  key_points: string;
  navigation?: string;
  description?: string;
  _document_owner: {
    id: number;
    first_name: string;
    last_name: string;
    profile_picture: {
      url: string;
    };
  };
} & GeneratedDocument;

type GeneratedUploadDocumentResponse =
  Vh3FrontendV2ApiDocumentationDocumentsUploadPdfPostData;

export type UploadDocumentResponse = {
  doc: DocumentationDocument;
  summary: string;
} & GeneratedUploadDocumentResponse;

/** Integrations the Knowledge Base can import a file from (vH3-Digital/paragon#54). */
export type DocumentImportIntegration = 'googledrive';

/** A file chosen in an integration's file picker. No file content. */
export type PickedIntegrationFile = {
  integration: DocumentImportIntegration;
  fileId: string;
  fileName: string;
  mimeType: string;
  sizeBytes?: number;
};

export type ImportDocumentRequest = {
  integration: DocumentImportIntegration;
  file_id: string;
  file_name: string;
  mime_type: string;
  share: boolean;
};

export enum DocumentListType {
  MyDocuments = 'myDocuments',
  SharedDocuments = 'sharedDocuments',
}
export enum DocumentTabType {
  MyDocuments = 'my-documents',
  SharedDocuments = 'shared-documents',
}
export const DocumentListTypeToTab: Record<DocumentListType, DocumentTabType> =
  {
    [DocumentListType.MyDocuments]: DocumentTabType.MyDocuments,
    [DocumentListType.SharedDocuments]: DocumentTabType.SharedDocuments,
  };

/** A page of a document that matched a Library search (Xano `/documents/search`). */
export type DocumentSearchPage = {
  pageNumber: number;
  guide: string;
  score: number;
  matchedWords: string[];
};

export type DocumentSearchVector =
  | 'title'
  | 'summary'
  | 'navigation'
  | 'document';

export type DocumentSearchHit = {
  documentId: string;
  name: string;
  passage?: string;
  /** Which vector matched the document. */
  vector?: DocumentSearchVector;
  score: number;
  rank?: number;
  /** Absent (not null) when page search did not run. Page text never comes back. */
  pages?: DocumentSearchPage[];
};

export type DocumentSearchResponse = {
  status: 'ok' | 'no_context';
  hits: DocumentSearchHit[];
};
